(() => {
  const links = () => document.querySelectorAll('.bugass-cart-link');

  const renderCount = (count) => {
    links().forEach((link) => {
      let badge = link.querySelector('.bugass-cart-link__count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'bugass-cart-link__count';
          badge.setAttribute('aria-hidden', 'true');
          link.appendChild(badge);
        }
        badge.textContent = count;
      } else {
        badge?.remove();
      }
      if (link.dataset.cartLabel) link.setAttribute('aria-label', link.dataset.cartLabel.replace('__COUNT__', count));
    });
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('.bugass-cart-link');
    if (!link || window.location.pathname === window.routes?.cart_url) return;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    event.preventDefault();
    drawer.open(link);
  });

  // Dawn's cart page refreshes only the lines, so the summary is rendered here.
  const refreshSummary = () => {
    const footer = document.getElementById('main-cart-footer');
    if (!footer) return;
    fetch(`${window.routes.cart_url}?section_id=${footer.dataset.id}`)
      .then((response) => response.text())
      .then((html) => {
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#main-cart-footer .cart__blocks');
        const current = footer.querySelector('.cart__blocks');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      })
      .catch(() => {});
  };

  // Cart actions don't all publish an event, but each one re-renders these elements.
  let pending;
  const refreshCount = () => {
    clearTimeout(pending);
    pending = setTimeout(() => {
      fetch(`${window.routes.cart_url}.js`)
        .then((response) => response.json())
        .then((cart) => renderCount(cart.item_count))
        .catch(() => {});
      refreshSummary();
    }, 200);
  };

  document.querySelectorAll('cart-drawer, cart-items').forEach((element) => {
    new MutationObserver(refreshCount).observe(element, { childList: true, subtree: true });
  });
})();
